<template>
    <div>
        <button type="button" class="btn btn-secondary btn_white mr-1" @click="handleAddOnCheckClick"
            style="padding: 0px !important; font-size: 14px; height: 34px !important; width: 120px !important;">
            <span>加算チェック</span>
        </button>
        <AddOnCheckDialog
            :add-on-check-data="addOnCheckData"
            ref="addOnCheckDialog"
        />
    </div>
</template>
<script>
import AddOnCheckDialog from '@/Pages/Shifts/Components/Dialog/AddOnCheckDialog';
import axios from 'axios';

export default {
    name: 'BtnAddOnCheck',
    components: {
        AddOnCheckDialog,
    },
    props: {
        officeId: {
            type: Number,
        },
        year: {
            type: String,
        },
        month: {
            type: String,
        },
    },
    data() {
        return {
            addOnCheckData: {},
        };
    },
    methods: {
        updateLoading(flg) {
            EventBus.$emit('updateLoading', flg);
        },
        showAddOnCheck() {
            this.$refs.addOnCheckDialog.openDialog();
        },
        async handleAddOnCheckClick() {            
            this.updateLoading(true);
            
            try {
                const response = await axios.get(route('shifts.add-on-check', { 
                    officeId: this.officeId,
                    year: Number(this.year),
                    month: Number(this.month),
                }));
                
                this.updateLoading(false);

                this.addOnCheckData = response.data;
                
                this.showAddOnCheck();
            } catch (error) {
                this.updateLoading(false);

                this.$swal({
                  title: 'エラー',
                  text: '加算チェックが取得できませんでした。',
                  icon: 'error'
                });
            }
        },
    },
}
</script>
